<div class="step-container">

    <nb-accordion multi>

        <nb-accordion-item>
            <nb-accordion-item-header>Practice and Goals</nb-accordion-item-header>
            <nb-accordion-item-body *ngIf="applicantData?.AddendumPTH">
                <app-pth-contemplation [isPreviewMode]="true"
                    [applicantData]="applicantData.AddendumPTH"></app-pth-contemplation>
            </nb-accordion-item-body>

            <nb-accordion-item-body *ngIf="!applicantData?.AddendumPTH">
                <div class="no-data-message">
                    <p>No data available for practice and goals.</p>
                </div>
            </nb-accordion-item-body>
        </nb-accordion-item>

        <nb-accordion-item>
            <nb-accordion-item-header>Accommodations</nb-accordion-item-header>
            <nb-accordion-item-body *ngIf="applicantData?.AccomodationRequest">
                <app-accommodation-details [isPreviewMode]="true"
                    [applicantData]="applicantData.AccomodationRequest"
                    [ApplicationTypeId]="ApplicationTypeId"></app-accommodation-details>
            </nb-accordion-item-body>

            <nb-accordion-item-body *ngIf="!applicantData?.AccomodationRequest">
                <div class="no-data-message">
                    <p>No data available for accommodation details.</p>
                </div>
            </nb-accordion-item-body>
        </nb-accordion-item>

        <nb-accordion-item>
            <nb-accordion-item-header>Your dates of availability for offering</nb-accordion-item-header>
            <nb-accordion-item-body *ngIf="applicantData?.ArrivalSchedule">
                <app-tentative-date [isPreviewMode]="true"
                    [applicantData]="applicantData.ArrivalSchedule"
                    [ApplicationTypeId]="ApplicationTypeId"></app-tentative-date>
            </nb-accordion-item-body>

            <nb-accordion-item-body *ngIf="!applicantData?.ArrivalSchedule">
                <div class="no-data-message">
                    <p>No data available for Requested Dates details.</p>
                </div>
            </nb-accordion-item-body>
        </nb-accordion-item>

    </nb-accordion>
</div>
